import { Component } from '@angular/core';
import { permissions } from '../../../permissions';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';

@Component({
    selector: 'app-order-headers-faq-modal',
    templateUrl: './order-headers-faq-modal.component.html',
    styleUrls: ['./order-headers-faq-modal.component.scss'],
    providers: [

    ]
})
export class OrderHeadersFaqModalComponent {

    public  permissions = permissions;

    constructor(
        public dialogRef: MatDialogRef<OrderHeadersFaqModalComponent>,
        public dialog: MatDialog,
    ) {
    }

    closeDialog(){
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/order-headers/order-headers-faq-modal/order-headers-faq-modal.component.ts